const pl = {
  coreLoginPanel: {
    sso: {
      loginButtonText: 'Zaloguj się przez SSO',
      toolTipText:
        'SSO - system logowania przeznaczony dla studentów oraz pracowników Politechniki Wrocławskiej'
    },
    local: {
      passwordText: 'Hasło',
      loginText: 'Nazwa użytkownika',
      submitButtonText: 'Zaloguj'
    },
    backToHomeText: 'Powrót',
    dividerText: 'lub',
    validation: {
      field: 'Pole'
    }
  }
};

export default pl;
